function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from 'firebase/app';
import 'firebase/firestore';
import { filterMixin } from '@/mixins/filter_mixin';
import ProjectsService from '@/apps/data-platform/services/master_data/projects_service';
import DataProfilingService from '@/apps/data-platform/services/data_quality/data_profiling_service';
import DataProfilingStepsService from '@/apps/data-platform/services/data_quality/data_profiling_steps_service';
import HistoryItem from '@/views/profiling/HistoryItem';
import QueryTableProfilingComponent from '@/apps/data-platform/modules/data_quality/components/QueryTableProfilingComponent';
import ProfilingExecuteItem from '@/components/profiling/ProfilingExecuteItem';
import FormMetadataProfiling from '@/components/FormMetadataProfiling';
import { envConfig, TYPE_CHANGE_METADA } from '@/js/constants';
import { loginObj } from '@/services/base';
import ProfilingExecuteError from '@/components/profiling/ProfilingExecuteError';
import PaginationBasic from '@/components/PaginationBasic.vue';
import utils from '@/js/utils';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import PaginationCatalog from '@/components/PaginationCatalog.vue';
import { mapState } from 'vuex';
export default {
  name: 'ProfilingHistoryPage',
  components: {
    HistoryItem: HistoryItem,
    QueryTableProfilingComponent: QueryTableProfilingComponent,
    FormMetadataProfiling: FormMetadataProfiling,
    ProfilingExecuteItem: ProfilingExecuteItem,
    ProfilingExecuteError: ProfilingExecuteError,
    PaginationBasic: PaginationBasic,
    DialogConfirmationComponent: DialogConfirmationComponent,
    PaginationCatalog: PaginationCatalog
  },
  mixins: [filterMixin],
  data: function data() {
    return {
      sortBy: 'creationTime',
      sortDesc: true,
      tabFlag: false,
      MODAL_NAME_PROFILING_VIEW: 'MODAL_NAME_PROFILING_VIEW',
      MODAL_NAME_PROFILING_EDIT: 'MODAL_NAME_PROFILING_EDIT',
      MODAL_NEW_PROFILING: 'MODAL_NEW_PROFILING',
      MODAL_TABLE_CONFIG: 'MODAL_TABLE_CONFIG',
      MODAL_CONFIRM_EXECUTE_PROFILING: 'MODAL_CONFIRM_EXECUTE_PROFILING',
      MODAL_PROFILING_ERROR: 'MODAL_PROFILING_ERROR',
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      isBusy: false,
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      },
      items: [],
      item: Object,
      projectListDict: Object,
      projectList: Array,
      domainList: Array,
      table: Object,
      tableExecute: Object,
      tableReference: {},
      filters: {},
      key_pagination: 1
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc'])), {}, {
    fields: function fields() {
      return [{
        key: 'tableReference.project',
        label: this.traductor('tablas.project'),
        sortable: true
      }, {
        key: 'tableReference.bigquery_dataset',
        label: 'Dataset',
        sortable: true
      }, {
        key: 'tableReference.bigquery_table',
        label: this.traductor('tablas.table'),
        sortable: true
      }, {
        key: 'applicant',
        label: this.traductor('tablas.applicant'),
        sortable: true
      }, {
        key: 'creationTime',
        label: this.traductor('tablas.creation_time'),
        sortable: true
      }, {
        key: 'finishTime',
        label: this.traductor('tablas.end_date'),
        sortable: true
      }, {
        key: 'status',
        label: this.traductor('tablas.status'),
        class: 'text-center',
        sortable: true
      }, {
        key: 'actions',
        label: this.traductor('tablas.actions'),
        class: 'text-left'
      }];
    },
    headers: function headers() {
      return [{
        value: 'tableReference.project',
        text: this.traductor('tablas.project'),
        sortable: true
      }, {
        value: 'tableReference.bigquery_dataset',
        text: 'Dataset',
        sortable: true
      }, {
        value: 'tableReference.bigquery_table',
        text: this.traductor('tablas.table'),
        sortable: true
      }, {
        value: 'applicant',
        text: this.traductor('tablas.applicant'),
        sortable: true,
        align: 'center'
      }, {
        value: 'creationTime',
        text: this.traductor('tablas.creation_time'),
        sortable: true,
        align: 'center'
      }, {
        value: 'finishTime',
        text: this.traductor('tablas.end_date'),
        sortable: true,
        align: 'center'
      }, {
        value: 'status',
        text: this.traductor('tablas.status'),
        sortable: true,
        align: 'center'
      }, {
        value: 'actions',
        text: this.traductor('tablas.actions'),
        align: 'left',
        width: '12%'
      }];
    },
    texts: function texts() {
      return {
        create: this.traductor('botones.boton_crear')
      };
    },
    rows: function rows() {
      return this.items.length;
    },
    modalTitle: function modalTitle() {
      return function (table) {
        return table.tableReference && "".concat(table.tableReference.project, ":").concat(table.tableReference.bigquery_dataset, ".").concat(table.tableReference.bigquery_table) || '';
      };
    },
    classStatus: function classStatus() {
      return function (data) {
        return {
          'text-center': true,
          'font-weight-bold': data.item.profilingRule.referenceRule !== undefined && data.item.profilingRule.referenceRule === '1'
        };
      };
    }
  }),
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.subscribeObserver();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return this.unsubscribeObserver();
          case 1:
            return _context2.a(2);
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    tabFlagFunction: function tabFlagFunction(tab) {
      this.tabFlag = tab;
    },
    getFirestoreCollection: function () {
      var _getFirestoreCollection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var user, db, ref;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              user = loginObj();
              db = firebase.firestore();
              ref = db.collectionGroup('profiling');
              return _context3.a(2, ref.where('domainTable', '==', user.domain).orderBy('creationTime', 'desc'));
          }
        }, _callee3);
      }));
      function getFirestoreCollection() {
        return _getFirestoreCollection.apply(this, arguments);
      }
      return getFirestoreCollection;
    }(),
    getRecords: function getRecords() {
      var _this = this;
      this.isBusy = true;
      var filters = this.getFilters();
      this.params = {
        pagination: utils.cloneJSON(this.pagination),
        filters: filters
      };
      this.params.pagination.limit++;
      DataProfilingService.getDataProfilingHistory(this.params).then(function (response) {
        if (response.data) {
          if (response.data.length > _this.pagination.limit) {
            //console.log("has next", response.data.result.length)
            _this.pagination.next = true;
          } else {
            //console.log("no has next", response.data.result.length)
            _this.pagination.next = false;
          }
          _this.pagination.total = response.data.length;
          _this.key_pagination += 1;
          _this.items = response.data;
          _this.isBusy = !_this.isBusy;
        } else {
          _this.pagination.next = false;
          _this.pagination.total = 0;
          _this.key_pagination += 1;
          _this.items = [];
        }
      });
    },
    getFilters: function getFilters() {
      var filters = [];
      for (var key in this.filters) {
        if (key === 'tableReference') {
          var tableReference = this.filters[key];
          if (Object.keys(tableReference).length) {
            for (var keyTable in tableReference) {
              filters.push({
                key: "".concat(key, ".").concat(keyTable),
                operator: '==',
                value: tableReference[keyTable]
              });
            }
          }
          filters.push({
            key: key,
            operator: '==',
            value: this.filters[key]
          });
        }
      }
      return filters;
    },
    onSearch: function onSearch() {
      var tableReference = this.tableReference;
      this.filters = {
        tableReference: tableReference
      };
      this.getRecords();
    },
    onCleanSearch: function onCleanSearch() {
      this.filters = {};
      this.getRecords();
    },
    updateList: function updateList(change, type) {
      this.isBusy = !this.isBusy;
      var foundIndex = this.items.findIndex(function (e) {
        return e.document_id === change.doc.id;
      });
      var index = foundIndex === -1 && type === 'added' ? 0 : foundIndex;
      var edit = change.doc.data();
      edit.document_id = change.doc.id;
      var edit_status = edit.status;
      if (edit_status === 'DONE' || edit_status === 'ERROR') {
        var params = {
          profilingDocument: edit.document_id
        };
      }
      this.isBusy = !this.isBusy;
      this.$set(this.items, index, edit);
      console.log(type, ' document ');
    },
    viewDetail: function viewDetail(item) {
      this.item = item;
      this.$refs[this.MODAL_NAME_PROFILING_VIEW].onOpen();
    },
    editProfiling: function editProfiling(item) {
      this.item = item;
      this.$refs[this.MODAL_NAME_PROFILING_EDIT].onOpen();
    },
    executeDetail: function executeDetail(item, type, process) {
      item.type = type;
      item.process = process;
      this.item = item;
      this.$refs[this.MODAL_CONFIRM_EXECUTE_PROFILING].onOpen();
    },
    executeDetailSend: function executeDetailSend(event) {
      if (event) {
        var params = {
          domainTable: this.item.domainTable,
          documentId: this.item.document_id,
          executionType: this.item.type,
          profilingProcess: this.item.process
        };
        DataProfilingStepsService.executeDataProfiling(params);
      }
      this.$refs[this.MODAL_CONFIRM_EXECUTE_PROFILING].onClose();
    },
    executeError: function executeError(item) {
      this.item = item;
      this.$refs[this.MODAL_PROFILING_ERROR].onOpen();
    },
    executeErrorSend: function executeErrorSend(type, process) {
      var params = {
        domainTable: this.item.domainTable,
        documentId: this.item.document_id,
        executionType: type,
        profilingProcess: process
      };
      DataProfilingStepsService.executeDataProfiling(params);
      this.$refs[this.MODAL_PROFILING_ERROR].onClose();
    },
    openTableModal: function openTableModal() {
      var _this2 = this;
      this.item = {};
      ProjectsService.getAllProjects().then(function (response) {
        _this2.domainList = response.data.domains;
        _this2.projectListDict = response.data.projects;
        _this2.$refs[_this2.MODAL_TABLE_CONFIG].onOpen();
      });
    },
    closeNewItem: function closeNewItem() {
      this.$refs[this.MODAL_TABLE_CONFIG].onClose();
    },
    submitNewItem: function submitNewItem(table) {
      this.table = table;
      this.$refs[this.MODAL_TABLE_CONFIG].onClose();
      this.$refs[this.MODAL_NEW_PROFILING].onOpen();
    },
    onSubmitNewProfiling: function onSubmitNewProfiling(tableExecute) {
      // this.tableExecute = tableExecute.data
      this.$refs[this.MODAL_NEW_PROFILING].onClose();
      // this.$bvModal.show(this.MODAL_CONFIRM_EXECUTE_PROFILING)
    },
    closeMetadataProfiling: function () {
      var _closeMetadataProfiling = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var event,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              event = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
              if (event) {
                event.preventDefault();
              }
              this.$refs[this.MODAL_NEW_PROFILING].onClose();
              _context4.n = 1;
              return this.getRecords();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function closeMetadataProfiling() {
        return _closeMetadataProfiling.apply(this, arguments);
      }
      return closeMetadataProfiling;
    }(),
    subscribeObserver: function () {
      var _subscribeObserver = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this3 = this;
        var docRef;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.getRecords();
            case 1:
              _context5.n = 2;
              return this.getFirestoreCollection();
            case 2:
              docRef = _context5.v;
              docRef.onSnapshot(function (querySnapshot) {
                querySnapshot.docChanges().forEach(function (change) {
                  if (change.type === 'modified') {
                    _this3.updateList(change, change.type);
                  }
                });
              });
              console.log('Subscribe Observer');
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function subscribeObserver() {
        return _subscribeObserver.apply(this, arguments);
      }
      return subscribeObserver;
    }(),
    unsubscribeObserver: function () {
      var _unsubscribeObserver = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var docRef;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.getFirestoreCollection();
            case 1:
              docRef = _context6.v;
              docRef.onSnapshot(function () {});
              console.log('Unsubscribe observer');
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function unsubscribeObserver() {
        return _unsubscribeObserver.apply(this, arguments);
      }
      return unsubscribeObserver;
    }(),
    closeEditProfiling: function closeEditProfiling() {
      this.$refs[this.MODAL_NAME_PROFILING_EDIT].onClose();
    },
    closeExecuteItem: function closeExecuteItem() {
      this.$bvModal.hide(this.MODAL_CONFIRM_EXECUTE_PROFILING);
    },
    closeExecuteError: function closeExecuteError() {
      this.$bvModal.hide(this.MODAL_PROFILING_ERROR);
    },
    changePage: function changePage(currentPage) {
      this.pagination.current = currentPage;
      this.pagination.offset = (this.pagination.current - 1) * this.pagination.limit;
      this.getRecords();
    }
  }
};